import { render, staticRenderFns } from "./arinvfrm-disabled.vue?vue&type=template&id=096bc4ef"
import script from "./arinvfrm-disabled.vue?vue&type=script&lang=js"
export * from "./arinvfrm-disabled.vue?vue&type=script&lang=js"
import style0 from "./arinvfrm-disabled.vue?vue&type=style&index=0&id=096bc4ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports